import { createStore } from 'vuex';
import CryptoJS from 'crypto-js';

// 암호화 키 (반드시 안전한 곳에 보관되어야 함)
const ENCRYPTION_KEY = 'adminPassKey950729930202';

interface WageInfo {
  basic_pay: number;
  overtime_pay: number;
  night_pay: number;
  holiday_pay: number;
  meal_pay: number;
  transportation_pay: number;
  other_pay: number;
  total_pay: number;
  work_days: number;
  overtime_hours: number;
  night_hours: number;
  holiday_hours: number;
}

interface SisulInfo {
  sisul_id: string;
  sisul_addr: string;
  sisul_tell: string;
  sisul_boss_name: string;
  sisul_boss_phone: string;
  sisul_boss_email: string;
  sisul_biz_num: string;
  sisul_bank: string;
  sisul_bank_num: string;
  sisul_bank_owner: string;
}

interface State {
  user: {
    id: string;
    name: string;
    role: number;
    role_name: string;
  } | null;
  drawer: boolean;
  mainDate: string;
  id: string | null;
  pw: string | null;
  role: number;
  roleName: string | null; // UI에서는 roleName으로 사용
  sisulName: string | null;
  empNum: string | null;
  code: string | null;
  name: string | null;
  isAutoLogin: boolean;
  NonStopId: string | null;
  NonStopPw: string | null;
  YYMM: string;
  SsECDEmpInfo: {
    emp_num: string;
    name: string;
    position: string;
    department: string;
  } | null;
  AdminSisulCode: string | null;
  AdminYYMM: string | null;
  AdminSisulId: string | null;
  AdminSisul: string | null;
  AdminSisulName: string | null;
  AdminBizGubun: string | null;
  AdminService: string[] | null;
  AdminEmpInfo: {
    emp_num: string;
    name: string;
    position: string;
    department: string;
  } | null;
  AdminWageInfo: {
    emp_num: string;
    name: string;
    position: string;
    department: string;
    wage_info: WageInfo;
  } | null;
  AdminUser: string;
  SsInfoBox: SisulInfo;
  snackbar: {
    show: boolean;
    text: string;
    color: string;
    timeout: number;
  };
}

const encrypt = (data: State) => {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();
  return encryptedData;
};

const decrypt = (encryptedData: string) => {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const saveState = (state: State, isAutoLogin: boolean) => {
  if (isAutoLogin) {
    // 자동 로그인일 경우 localStorage에만 저장
    localStorage.setItem('vuex_state', encrypt(state));
    sessionStorage.removeItem('vuex_state'); // sessionStorage에서 제거
  } else {
    // 자동 로그인이 아닐 경우 sessionStorage에만 저장
    sessionStorage.setItem('vuex_state', encrypt(state));
    localStorage.removeItem('vuex_state'); // localStorage에서 제거
  }
};

const store = createStore<State>({
  state: {
    drawer: false,
    mainDate: '',
    id: null,
    pw: null,
    role: 0,
    roleName: null,
    sisulName: null,
    empNum: null,
    code: null,
    name: null,
    isAutoLogin: false, // 자동 로그인 여부
    NonStopId: null,
    NonStopPw: null,
    YYMM: '',
    user: null,
    SsECDEmpInfo: null,
    AdminSisulCode: null,
    AdminYYMM: null,
    AdminSisulId: null,
    AdminSisul: null,
    AdminSisulName: null,
    AdminBizGubun: null,
    AdminService: null,
    AdminEmpInfo: null,
    AdminWageInfo: null,
    AdminUser: '',
    SsInfoBox: {
      sisul_id: '',
      sisul_addr: '',
      sisul_tell: '',
      sisul_boss_name: '',
      sisul_boss_phone: '',
      sisul_boss_email: '',
      sisul_biz_num: '',
      sisul_bank: '',
      sisul_bank_num: '',
      sisul_bank_owner: ''
    },
    snackbar: {
      show: false,
      text: '',
      color: '',
      timeout: 0
    }
  },
  mutations: {
    setId(state, id) {
      state.id = id;
      saveState(state, state.isAutoLogin);
    },
    setRole(state, role) {
      state.role = role;
      saveState(state, state.isAutoLogin);
    },
    setRoleName(state, roleName) {
      state.roleName = roleName;
      saveState(state, state.isAutoLogin);
    },
    setSisulName(state, sisulName) {
      state.sisulName = sisulName;
      saveState(state, state.isAutoLogin);
    },
    setEmpNum(state, empNum) {
      state.empNum = empNum;
      saveState(state, state.isAutoLogin);
    },
    
    setCode(state, code) {
      state.code = code;
      saveState(state, state.isAutoLogin);
    },
    setName(state, name) {
      state.name = name;
      saveState(state, state.isAutoLogin);
    },
    setDrawer(state, value) {
      state.drawer = value;
    },
    setAutoLogin(state, value) {
      state.isAutoLogin = value;
      saveState(state, value);
    },
    clearState(state) {
      state.id = null;
      state.role = 0;
      state.roleName = null;
      state.sisulName = null;
      state.empNum = null;
      state.code = null;
      state.name = null;
      state.isAutoLogin = false;
      state.snackbar = {
        show: false,
        text: '',
        color: '',
        timeout: 0
      };
      localStorage.removeItem('vuex_state');
      sessionStorage.removeItem('vuex_state');
    },
    setNonStopId(state, NonStopId) {
      state.NonStopId = NonStopId;
      sessionStorage.setItem('getNonStopId', encrypt(state));
    },
    setNonStopPw(state, NonStopPw) {
      state.NonStopPw = NonStopPw;
      sessionStorage.setItem('getNonStopPw', encrypt(state));
    },
    setSsECDEmpInfo(state, empInfo) {
      state.SsECDEmpInfo = empInfo;
      saveState(state, state.isAutoLogin);
    },
    setAdminSisulCode(state, code) {
      state.AdminSisulCode = code;
      saveState(state, state.isAutoLogin);
    },
    setAdminYYMM(state, yymm) {
      state.AdminYYMM = yymm;
      saveState(state, state.isAutoLogin);
    },
    setAdminSisulId(state, id) {
      state.AdminSisulId = id;
      saveState(state, state.isAutoLogin);
    },
    setAdminEmpInfo(state, empInfo) {
      state.AdminEmpInfo = empInfo;
      saveState(state, state.isAutoLogin);
    },
    setAdminWageInfo(state, wageInfo) {
      state.AdminWageInfo = wageInfo;
      saveState(state, state.isAutoLogin);
    },
    setAdminSisul(state, sisul) {
      state.AdminSisul = sisul;
      saveState(state, state.isAutoLogin);
    },
    setAdminSisulName(state, name) {
      state.AdminSisulName = name;
      saveState(state, state.isAutoLogin);
    },
    setAdminBizGubun(state, bizGubun) {
      state.AdminBizGubun = bizGubun;
      saveState(state, state.isAutoLogin);
    },
    setAdminService(state, service) {
      state.AdminService = service;
      saveState(state, state.isAutoLogin);
    },
    setSsInfoBox(state, info) {
      state.SsInfoBox = info;
      saveState(state, state.isAutoLogin);
    },
    showSnackbar(state, { text, color = 'info', timeout = 3000 }) {
      state.snackbar = {
        show: true,
        text,
        color,
        timeout
      };
    },
    hideSnackbar(state) {
      state.snackbar.show = false;
    },
    clearAdminState(state) {
      state.AdminSisulCode = null;
      state.AdminYYMM = null;
      state.AdminSisulId = null;
      state.AdminSisul = null;
      state.AdminSisulName = null;
      state.AdminBizGubun = null;
      state.AdminService = null;
      state.AdminEmpInfo = null;
      state.AdminWageInfo = null;
      saveState(state, state.isAutoLogin);
    }
  },
  actions: {
    // roleName 매개변수는 Member에서의 role_name 값을 수신
    login({ commit }, { id, role, roleName, sisulName, empNum, name, code, autoLogin }) {
      commit('setId', id);
      commit('setRole', role);
      commit('setRoleName', roleName); // role_name 값을 roleName으로 저장
      commit('setSisulName', sisulName);
      commit('setEmpNum', empNum);
      commit('setName', name);
      commit('setCode', code);
      commit('setAutoLogin', autoLogin); // 자동 로그인 설정
    },
    toggleDrawer({ commit, state }) {
      commit('setDrawer', !state.drawer);
    },
    logout({ commit }) {
      commit('clearState'); // 상태 초기화 및 스토리지 비우기
    },
    setSsECDEmpInfo({ commit }, empInfo) {
      commit('setSsECDEmpInfo', empInfo);
    },
    setAdminSisulCode({ commit }, code) {
      commit('setAdminSisulCode', code);
    },
    setAdminYYMM({ commit }, yymm) {
      commit('setAdminYYMM', yymm);
    },
    setAdminEmpInfo({ commit }, empInfo) {
      commit('setAdminEmpInfo', empInfo);
    },
    setAdminWageInfo({ commit }, wageInfo) {
      commit('setAdminWageInfo', wageInfo);
    },
    setAdminSisulId({ commit }, id) {
      commit('setAdminSisulId', id);
    },
    setAdminSisul({ commit }, sisul) {
      commit('setAdminSisul', sisul);
    },
    setAdminSisulName({ commit }, name) {
      commit('setAdminSisulName', name);
    },
    setAdminBizGubun({ commit }, bizGubun) {
      commit('setAdminBizGubun', bizGubun);
    },
    setAdminService({ commit }, service) {
      commit('setAdminService', service);
    },
    clearAdminState({ commit }) {
      commit('clearAdminState');
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.role,
    id: (state) => state.id,
    pw: (state) => state.pw,
    role: (state) => state.role,
    roleName: (state) => state.roleName,
    sisulName: (state) => state.sisulName,
    empNum: (state) => state.empNum,
    name: (state) => state.name,
    code: (state) => state.code,
    getDrawerState: (state) => state.drawer,
    // 새로운 역할 확인 getter 추가
    isSuperVisor: (state) => state.role === 9,
    isTopManager: (state) => state.role === 8,
    isManager: (state) => state.role === 7,
    SsECDEmpInfo: (state) => state.SsECDEmpInfo,
    AdminSisulCode: (state) => state.AdminSisulCode,
    AdminYYMM: (state) => state.AdminYYMM,
    AdminEmpInfo: (state) => state.AdminEmpInfo,
    AdminWageInfo: (state) => state.AdminWageInfo,
    AdminSisulId: (state) => state.AdminSisulId,
    AdminSisul: (state) => state.AdminSisul,
    AdminSisulName: (state) => state.AdminSisulName,
    AdminBizGubun: (state) => state.AdminBizGubun,
    AdminService: (state) => state.AdminService,
  },
});

// 페이지 로딩 시 저장된 암호화된 상태를 복호화하여 불러옵니다.
const savedState = localStorage.getItem('vuex_state') || sessionStorage.getItem('vuex_state');
if (savedState) {
  try {
    store.replaceState(decrypt(savedState));
    
  } catch (error) {
    console.error('저장된 상태를 복호화하는 중 오류가 발생했습니다:', error);
    localStorage.removeItem('vuex_state');
    sessionStorage.removeItem('vuex_state');
  }
}
const savedNonStopId = sessionStorage.getItem('getNonStopId');
if (savedNonStopId) {
  try {
    store.commit('setNonStopId', decrypt(savedNonStopId).NonStopId);
  } catch (error) {
    console.error('NonStopId를 복호화하는 중 오류가 발생했습니다:', error);
    sessionStorage.removeItem('getNonStopId');
  }
}
const savedNonStopPw = sessionStorage.getItem('getNonStopPw');
if (savedNonStopPw) {
  try {
    store.commit('setNonStopPw', decrypt(savedNonStopPw).NonStopPw);
  } catch (error) {
    console.error('NonStopPw를 복호화하는 중 오류가 발생했습니다:', error);
    sessionStorage.removeItem('getNonStopPw');
  }
}
export default store;
